import { ItemAction } from '../types';

export function shouldRender<ItemType>(action: ItemAction<ItemType>, item?: ItemType): boolean {
  if (!('visible' in action)) return true;
  return typeof action.visible === 'function' ? action.visible(item) : action.visible!;
}
